import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import '../Button/index.js';
import { Button as ButtonMemoized } from '../Button/Button.js';

var CloseButton = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    top: 0,
    end: 0
  }, /*#__PURE__*/React.createElement(ButtonMemoized, _extends({
    leadingIcon: "fill.symbol.close"
  }, props)));
});
CloseButton.displayName = 'CloseButton';

export { CloseButton };
//# sourceMappingURL=CloseButton.js.map
